<template>
  <div class="push-down" data-test-create-member-step3>
    <h1 v-html="matchedAffinityBrandModel.redirectComponentModel.title" />
    <div data-test-body>
      <p v-html="matchedAffinityBrandAnswerString" />
      <div v-html="matchedAffinityBrandModel.redirectComponentModel.body" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Utility from '@/common/UtilityFunctions.js';

export default {
  name: 'EligibilityResult',
  computed: {
    ...mapState({
      eligibilityResultModel: (state) => state.createMember.vueModel.stepThreeBrandRedirection,
      matchedAffinityId: (state) => state.createMember.matchedBrandAffinityId,
      affinityMatchedQuestion: (state) => state.createMember.affinityMatchedQuestion
    }),
    matchedAffinityBrandModel() {
      return this.eligibilityResultModel.availableBrands.find(
        (element) => element.brandAffinity.toString() === this.matchedAffinityId
      );
    },
    matchedAffinityBrandAnswerString() {
      const question = this.affinityMatchedQuestion;
      const answerString =
        question.type === 1 ? question.affinityMatchString : question.value.label;
      const answerStringWithLowerCaseStartLetter =
        answerString.charAt(0).toLowerCase() + answerString.substring(1);
      return (
        this.matchedAffinityBrandModel.redirectComponentModel.weCanOfferYouOn +
        ' <strong>' +
        answerStringWithLowerCaseStartLetter +
        '</strong>'
      );
    }
  },
  mounted() {
    this.$store.dispatch('createMember/setButtons', {
      prevButton: {
        path: null,
        class: null,
        label: null,
        redirectTo: null
      },
      nextButton: {
        path: null,
        class: null,
        label: null,
        redirectTo: null
      }
    });

    this.$store.commit(
      'createMember/setMatchedBrandAffinityLink',
      this.matchedAffinityBrandModel.redirectComponentModel.link
    );
    Utility.scrollToTop();
  }
};
</script>
